import { PhoneIcon } from '@heroicons/react/24/outline';
import React from 'react';

import { DiscriminatedVoiceAiCallCompletedEvent } from '@/services/api/generated/matterChangesService';

import {
  ActivityBody,
  ActivityDescription,
  ActivityIcon,
  ActivityItem,
  ActivityTitle,
} from '../activity-feed-v2';
import { getUserFromEvent } from '../activity-feed-v2/ActivityDiffList';
import { truncate } from '../activity-feed-v2/utils';

export interface VoiceAiCallCompletedEventProps {
  event: DiscriminatedVoiceAiCallCompletedEvent;
}

export const VoiceAiCallCompletedEvent: React.FC<
  VoiceAiCallCompletedEventProps
> = ({ event }) => {
  const { provider_name, summary, request_status } = event.payload;
  const user = getUserFromEvent(event);

  const icon = (
    <ActivityIcon
      icon={
        <div className="flex h-6 w-6 items-center justify-center rounded-full bg-green-100">
          <PhoneIcon className="h-4 w-4 text-green-600" />
        </div>
      }
    />
  );

  const body = (
    <ActivityBody>
      {provider_name && <ActivityTitle>{provider_name}</ActivityTitle>}
      <div className="mt-1 space-y-1">
        {summary && (
          <ActivityDescription className="italic">
            {truncate(summary, 120)}
          </ActivityDescription>
        )}
        {request_status && (
          <ActivityDescription>Status: {request_status}</ActivityDescription>
        )}
      </div>
    </ActivityBody>
  );

  return (
    <ActivityItem
      icon={icon}
      title="Call Placed"
      timestamp={new Date(event.occurred_at ?? new Date())}
      user={user}
      body={body}
    />
  );
};
